import { prefixes, prependIntlIds } from "../../utils";

const unprefixedVersionTableHeaderMessages = {
  isActive: "Aktivní",
  version: "Verze",
  savedDatetime: "Čas uložení",
  name: "Jméno",
  creatorUsername: "Vytvořeno uživatelem",
};

export default prependIntlIds(
  prefixes.versionTableHeader,
  unprefixedVersionTableHeaderMessages
);
